export default "__VITE_ASSET__BShjAcqD__"